import { render, staticRenderFns } from "./FlightCardDetails.vue?vue&type=template&id=250c6202&scoped=true"
import script from "./FlightCardDetails.vue?vue&type=script&lang=js"
export * from "./FlightCardDetails.vue?vue&type=script&lang=js"
import style0 from "./FlightCardDetails.vue?vue&type=style&index=0&id=250c6202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c6202",
  null
  
)

export default component.exports